import React from "react";
import { Navigate } from "react-router-dom";
import { useRoles } from "../security/RolesProvider/RolesProvider";
import { useAuth } from "../contexts/AuthProvider/AuthProvider";
import { userRoles } from "../contexts/AuthProvider/AuthProvider";
import {
  getAccessibleModulePermissions,
  isAccessibleModule,
} from "../security/isModuleAccess";

import { PremissionsProvider } from "../security/PremissionsProvider/PremissionsProvider";

interface IAuthorizedRouteProps {
  moduleIds?: string[];
  moduleUuids?: string[];
  allowedRoles?: (keyof typeof userRoles)[];
  allowFullAccess?: boolean;
  children: React.ReactNode;
}

export const AuthorizedRoute: React.FC<IAuthorizedRouteProps> = (props) => {
  const { moduleIds, allowedRoles, allowFullAccess, moduleUuids } = props;
  const { roles } = useRoles();
  const { user } = useAuth();

  // Check role-based access if allowedRoles is provided
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role_value as keyof typeof userRoles)) {
      return <Navigate to="/access" />;
    }
  }

  // Check module-based access if moduleIds is provided
  if (moduleIds && moduleIds.length > 0) {
    if (!isAccessibleModule(moduleIds, roles, allowFullAccess)) {
      return <Navigate to="/access" />;
    }

    const permissions = getAccessibleModulePermissions(
      moduleIds,
      roles,
      allowFullAccess
    );

    return (
      <PremissionsProvider premissions={permissions}>
        {props.children}
      </PremissionsProvider>
    );
  }

  // If only role-based access is required (no moduleIds), render children directly
  return <>{props.children}</>;
};
